import Vue from 'vue'
import axios from 'axios'
import router from '../router'

axios.defaults.baseURL = '/teacher-archives'
Vue.prototype.$axios = axios

// 3. 配置请求拦截器
// 所有的请求, 在真正被发送出去之前, 都会经过请求拦截器, 我们可以在请求拦截器中进行处理
axios.interceptors.request.use(function (config) {
  return config
  // console.log(" config",config);
  // //统一加上应用包名
  // let {url,method,data,params,responseType}=config;
  // if (responseType == "arraybuffer") {
  //   return config
  // }
  // else {
  //   if (params && params.clientPackage) {
  //     params.clientPackage = params.clientPackage || "com.xueduoduo.teacher.archives.pc"
  //   }
  //   if (data) {
  //     if (typeof data=="string") {
  //       data=JSON.parse(data)
  //       Object.assign(data,{clientPackage:"com.xueduoduo.teacher.archives.pc"})
  //       data=JSON.stringify(data)
  //       console.log("data",data);
  //     }else{
  //       Object.assign(data,{clientPackage:"com.xueduoduo.teacher.archives.pc"})
  //     }
  //   }
  //   return config
  // }



  // 在发送请求之前做些什么
  // 在请求拦截器中, 给每个请求, 统一加上token字段
  //config.headers.Authorization = localStorage.getItem('token')

}, function (error) {
  // 对请求错误做些什么
  return Promise.reject(error)
})

// 4. 配置响应拦截器
// 所有的响应, 在真正被.then 和 .catch 处理之前, 都会先经过响应拦截器
axios.interceptors.response.use(function (response) {
  //过期
  if (response.data.resultCode === 20001) {
    router.push("/login")
  }
  if (['/teacher-archives/teacherScore/exportTeacherScoreInfoDetail', '/teacher-archives/rpt/exportTeacherModelCount'].indexOf(response?.config.url) != -1) {
    return response
  }
  return response.data
}, function (error) {
  // 对响应错误做点什么
  return Promise.reject(error)
})

export default axios
